import { render } from "./Registration.vue?vue&type=template&id=ae8d93b6&scoped=true"
import script from "./Registration.vue?vue&type=script&lang=js"
export * from "./Registration.vue?vue&type=script&lang=js"

import "./Registration.vue?vue&type=style&index=0&id=ae8d93b6&scoped=true&lang=css"
import "@/assets/css/style_form_page.css?vue&type=style&index=1&id=ae8d93b6&lang=css&scoped=true"
import "@/assets/css/style_form_parts.css?vue&type=style&index=2&id=ae8d93b6&lang=css&scoped=true"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae8d93b6"]])

export default __exports__